










































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import copy from 'copy-to-clipboard'
import type { ConfiguracaoDaLoja, FormLoja, Loja } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { maiorOuIgualAUm, maiorOuIgualAZero, obrigatorio } from '@/shareds/regras-de-form'
import SeletorDeTabelaDePreco from '@/components/tabeladepreco/SeletorDeTabelaDePreco.vue'
import RevealPasswordField from '@/components/ui/RevealPasswordField.vue'
import {
	avisoAtivo,
	camposAoGravar,
	condicaoDoPai,
	estaVazio,
	filhosDe,
	foraDoPadrao,
	lerParametro,
	motivoDeDesabilitado,
	paiSatisfeito,
	valoresIguais,
} from '@/shareds/nova-edicao-de-loja/catalogo-de-parametros'
import type { ParametroDaLoja } from '@/shareds/nova-edicao-de-loja/catalogo-de-parametros'
import { motivoDoResultado, realcarBusca } from '@/shareds/nova-edicao-de-loja/busca'

const REGRAS = { maiorOuIgualAZero, maiorOuIgualAUm, obrigatorio }

@Component({
	name: 'LinhaDeParametro',
	components: { SeletorDeTabelaDePreco, RevealPasswordField },
})
export default class LinhaDeParametro extends Vue {
	@Prop({ type: Object, required: true }) parametro!: ParametroDaLoja
	@Prop({ type: Object, required: true }) loja!: FormLoja
	@Prop({ type: Object, default: null }) anterior!: FormLoja | null
	@Prop({ type: Object, required: true }) padrao!: Partial<ConfiguracaoDaLoja>
	@Prop({ type: Array, required: true }) lista!: ParametroDaLoja[]
	@Prop({ type: String, default: '' }) busca!: string
	@Prop({ type: Boolean, default: false }) plana!: boolean
	@Prop({ type: String, default: null }) destaque!: string | null
	@Prop({ type: Array, default: () => [] }) lojasDoGrupoEconomico!: Loja[]
	@Prop({ type: Boolean, default: false }) carregandoLojasDoGrupoEconomico!: boolean

	detalheAberto = false

	get configuracao() {
		return this.loja.configuracaoDaLoja
	}

	get valor(): unknown {
		return lerParametro(this.configuracao, this.parametro)
	}

	set valor(valor: unknown) {
		camposAoGravar(this.parametro, valor).forEach(({ campo, valor: novo }) => this.$set(this.configuracao, campo, novo))
	}

	get itens() {
		return (this.parametro.opcoes || []).map(({ valor, texto }) => ({ text: texto, value: valor }))
	}

	get quantidadeSelecionada() {
		return Array.isArray(this.valor) ? this.valor.length : 0
	}

	get filhos() {
		return this.plana ? [] : filhosDe(this.parametro.id, this.lista)
	}

	get filhosVisiveis() {
		return this.filhos.filter(filho => paiSatisfeito(this.configuracao, filho))
	}

	get filhosOcultos() {
		return this.filhos.filter(filho => !paiSatisfeito(this.configuracao, filho))
	}

	get textoDosOcultos() {
		const filho = this.filhosOcultos[0]
		if (this.parametro.tipo === 'escolha') {
			const opcao = (this.parametro.opcoes || []).find(({ valor }) => valor === filho.mostraSe)
			return `com "${opcao ? opcao.texto : filho.mostraSe}"`
		}
		if (filho.mostraSe === 'preenchido') return 'com este campo preenchido'
		return filho.mostraSe ? 'com esta opção ligada' : 'com esta opção desligada'
	}

	get oculto() {
		return !paiSatisfeito(this.configuracao, this.parametro)
	}

	get condicaoDoPai() {
		return condicaoDoPai(this.parametro)
	}

	get alterado() {
		return !!this.anterior &&
			!valoresIguais(lerParametro(this.anterior.configuracaoDaLoja, this.parametro), this.valor)
	}

	get fora() {
		return !this.alterado && foraDoPadrao(this.configuracao, this.padrao, this.parametro)
	}

	get textoDoPadrao() {
		const padrao = lerParametro(this.padrao, this.parametro)
		const { tipo, unidade, opcoes } = this.parametro
		if (tipo === 'sw') return padrao ? 'ligado' : 'desligado'
		if (estaVazio(padrao)) return 'vazio'
		if (opcoes) {
			const textos = (Array.isArray(padrao) ? padrao : [padrao])
				.map(valor => (opcoes.find(opcao => opcao.valor === valor) || { texto: String(valor) }).texto)
			return textos.join(', ')
		}
		if (tipo === 'num') return unidade === 'R$' ? `R$ ${padrao}` : `${padrao}${unidade ? ` ${unidade}` : ''}`
		return String(padrao)
	}

	get motivo() {
		return motivoDeDesabilitado(this.configuracao, this.parametro)
	}

	get desabilitado() {
		return !!this.motivo || (this.oculto && this.plana)
	}

	get aviso() {
		return avisoAtivo(this.configuracao, this.parametro)
	}

	get motivoDaBusca() {
		return this.busca ? motivoDoResultado(this.parametro, this.busca) : null
	}

	get regras() {
		const regra = this.parametro.regra
		return regra && !this.oculto ? [REGRAS[regra]] : []
	}

	realcar(texto: string) {
		return realcarBusca(texto, this.busca)
	}

	desfazer() {
		if (!this.anterior) return
		const anterior = this.anterior.configuracaoDaLoja as unknown as Record<string, unknown>
		const campos = this.parametro.grava || (this.parametro.campo ? [this.parametro.campo] : [])
		campos.forEach(campo => this.$set(this.configuracao, campo, JSON.parse(JSON.stringify(anterior[campo] ?? null))))
	}

	aoDigitarTelefone(texto: string) {
		const numeros = (texto || '').replace(/\D/g, '').substring(0, 11)
		let formatado = ''
		if (numeros.length > 0) formatado += `(${numeros.slice(0, 2)}`
		if (numeros.length >= 3) formatado += `) ${numeros.slice(2, 7)}`
		if (numeros.length >= 8) formatado += `-${numeros.slice(7, 11)}`
		this.valor = formatado
	}

	copiarLink() {
		const { href } = this.$router.resolve({
			name: this.$route.name || undefined,
			params: this.$route.params,
			query: { secao: this.parametro.assunto, p: this.parametro.id },
		})
		const copiou = copy(`${window.location.origin}${href}`)
		if (!copiou) {
			AlertModule.setError('Não foi possível copiar o link.')
			return
		}
		AlertModule.setSuccess('Link copiado. Quem abrir vai direto para esta configuração.')
	}
}
